// extracted by mini-css-extract-plugin
export default {"actions":"styles_actions__6wydy","btn":"styles_btn__RccWB","loader":"styles_loader__S6Uof","cancel":"styles_cancel__eY1ev"};